module.exports = __webpack_public_path__ + "img/4-1.02bae7b3.svg";